'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import * as ThemeQueryField from '../../constants/ThemeQueryField';
import RouterFilterTagButton from '../storefront/RouterFilterTagButton';
const MAX_UNEXPANDED_TAGS = 3;

const renderFilterTagButton = ({
  isPreview,
  onClick,
  value,
  queryField,
  translateTag
}) => /*#__PURE__*/_jsx(RouterFilterTagButton, {
  className: "m-left-0 m-right-1",
  disabled: isPreview,
  onClick: onClick,
  queryField: queryField,
  value: value,
  children: translateTag ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: translateTag(value)
  }) : value
}, `${queryField}-${value}`);

const ExpandableTagsSection = ({
  isPreview,
  onTrackInteraction,
  queryField,
  tags,
  translateTag
}) => {
  const expandCount = tags.size - MAX_UNEXPANDED_TAGS;
  const shortenedTagsList = tags.slice(0, MAX_UNEXPANDED_TAGS);
  const [expanded, setExpanded] = useState(false);
  const trackInteraction = useCallback((action, eventProperties = {}) => {
    onTrackInteraction(action, Object.assign({}, eventProperties, {
      section: 'sidebar about',
      filter: queryField
    }));
  }, [onTrackInteraction, queryField]);
  const trackFilterTagClick = useCallback(value => {
    trackInteraction('click filter tag', {
      value
    });
  }, [trackInteraction]);

  if (expanded || tags.size <= MAX_UNEXPANDED_TAGS) {
    return tags.map(value => renderFilterTagButton({
      isPreview,
      onClick: () => trackFilterTagClick(value),
      queryField,
      translateTag,
      value
    }));
  }

  return /*#__PURE__*/_jsxs(UIFlex, {
    alignment: "center",
    wrap: "wrap",
    children: [shortenedTagsList.map(value => renderFilterTagButton({
      isPreview,
      onClick: () => trackFilterTagClick(value),
      queryField,
      translateTag,
      value
    })), /*#__PURE__*/_jsxs(UIButton, {
      use: "transparent",
      onClick: () => {
        setExpanded(true);
        trackInteraction('click expand tags link');
      },
      className: "p-x-0 p-y-1",
      responsive: false,
      children: ["+", expandCount]
    })]
  });
};

ExpandableTagsSection.propTypes = {
  isPreview: PropTypes.bool.isRequired,
  onTrackInteraction: PropTypes.func.isRequired,
  queryField: PropTypes.oneOf(Object.values(ThemeQueryField)).isRequired,
  tags: PropTypes.instanceOf(Immutable.List).isRequired,
  translateTag: PropTypes.func
};
export default ExpandableTagsSection;